import React, {useState,useEffect} from "react";
import  "./ContactUs.css";
import Form from "./Form";

const ContactUs = React.memo(props => {
    useEffect(()=>{
        
    },[]);
    let mailTo = props.mailTo;
        return (
        <React.Fragment>
        <div className='contact-us'> 
                    <Form title={props.title} link={props.link} mainURL={props.mainURL} mailTo={mailTo} />
                    </div>
        </React.Fragment>
        );
});
export default ContactUs;